// @flow strict

import * as React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

import ansaradaLogo from '../../static/images/ansarada_logo.png';

type Props = {
  style?: $Shape<CSSStyleDeclaration>,
  className?: string,
  children: React.Node,
  heading: string | React.Node,
  subHeading: string | React.Node,
  illustrationSrc: string,
};

const UpflowyLayout = ({
  style,
  className,
  children,
  heading,
  subHeading,
  illustrationSrc,
}: Props) => {
  const containerStyle = classnames(styles.container, className);

  return (
    <div className={containerStyle} style={style}>
      <main>
        <div className={styles.logo}>
          <img src={ansaradaLogo} alt="Ansarada logo" />
        </div>
        <h1>{heading}</h1>
        <p>{subHeading}</p>

        {children}
      </main>

      <section>{illustrationSrc && <img src={illustrationSrc} alt="illustration" />}</section>
    </div>
  );
};

export default UpflowyLayout;
